import { Button, Grid, Paper, Link, Alert } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { post } from 'src/services/http-service';
import storageService from 'src/services/storage-service';
import { useNavigate } from 'react-router-dom';
import Loading from 'src/components/Loading';

function AutoLoginPage({ onSuccess }) {
	const [search] = useSearchParams();
	const navigate = useNavigate();

	const [errorMessage, setErrorMessage] = useState(null);
	const licenseKey =
		search.get('licensNyckel') ||
		search.get('licensnyckel') ||
		search.get('licensekey') ||
		search.get('licenseKey') ||
		search.get('password') ||
		search.get('key') ||
		null;

	useEffect(() => {
		const validateLoginResult = (loginResponse, errorMessage) => {
			if (loginResponse.status === 'success') {
				storageService.save(loginResponse);
				onSuccess();
				navigate('/');
			} else {
				setErrorMessage(
					errorMessage || 'Inloggningen misslyckades. Försök igen.'
				);
			}
		};

		const loginByLicensekey = async () => {
			const form = new FormData();

			form.append('licenseKey', licenseKey);
			const loginResponse = await post('/login', form);

			validateLoginResult(
				loginResponse,
				'Inloggningen misslyckades. Kontrollera att du skrivit in din licensnyckel korrekt.'
			);
		};

		const loginByIP = async () => {
			const loginResponse = await post('/login/ip');

			validateLoginResult(
				loginResponse,
				'Inloggningen misslyckades. Kontrollera att du är ansluten till rätt nätverk.'
			);
		};

		if (licenseKey) {
			loginByLicensekey();
		} else {
			loginByIP();
		}
	}, [licenseKey, navigate, onSuccess]);

	if (!errorMessage) {
		return <Loading />;
	}

	return (
		<Box
			component={'div'}
			style={{
				background: 'url(/login_background.jpg)',
				backgroundSize: 'cover',
				position: 'fixed',
				width: '100%',
				height: '100%',
				top: 0,
				left: 0,
				zIndex: 0,
			}}
		>
			<Grid
				container
				spacing={0}
				direction="column"
				alignItems="center"
				justifyContent="start"
				sx={{
					minHeight: '100vh',
					marginTop: {
						xs: 0,
						sm: 8,
						md: 12,
					},
				}}
			>
				<Grid item xs={3}>
					<Paper elevation={3} sx={{ zIndex: 10, maxWidth: 700 }}>
						<Box p={8}>
							<Box
								component="div"
								display="flex"
								flexDirection="column"
								alignItems="center"
							>
								<Link href="/">
									<Box
										component={'img'}
										src="/logo.svg"
										alt="InfoSoc Logo"
										width={220}
										mb={8}
									/>
								</Link>
							</Box>
							<Box mb={4}>
								<Alert variant="filled" severity="error">
									{errorMessage}
								</Alert>
							</Box>
							<Box
								component="div"
								display="flex"
								flexDirection="row"
								justifyContent={'flex-end'}
							>
								<Button
									style={{ marginTop: 16 }}
									onClick={() => window.location.reload()}
									variant="contained"
								>
									Ladda om sidan
								</Button>
								<Button
									style={{ marginLeft: 12, marginTop: 16 }}
									onClick={() => navigate('/')}
									variant="outlined"
								>
									Till login
								</Button>
							</Box>
						</Box>
					</Paper>
				</Grid>
			</Grid>
		</Box>
	);
}

export default AutoLoginPage;
